import { prop, singleton } from '@difizen/mana-app';

@singleton()
export class CloudLabLibroService  {
  @prop()
  globalEnvStatus:any;

}
